import script from "./TowerDriver.vue?vue&type=script&setup=true&lang=ts"
export * from "./TowerDriver.vue?vue&type=script&setup=true&lang=ts"

import "./TowerDriver.vue?vue&type=style&index=0&id=18207683&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18207683"]])

export default __exports__